import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-inline-loader',
  standalone: true,
  templateUrl: './inline-loader.component.html',
  styleUrl: './inline-loader.component.scss',
  imports: [CommonModule],
})
export class InlineLoaderComponent {
  size = input<'sm' | 'md' | 'lg'>('md');
  color = input<'light' | 'primary'>('primary');
}
